export default "__VITE_ASSET__BCFvwdlM__"